import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicSafety/img/1.avif';
import function1 from '@src/assets/images/solution/publicSafety/img/function1.avif';
import function2 from '@src/assets/images/solution/publicSafety/img/function2.avif';
import function3 from '@src/assets/images/solution/publicSafety/img/function3.avif';
import function4 from '@src/assets/images/solution/publicSafety/img/function4.avif';
import image3 from '@src/assets/images/solution/publicSafety/img/3.avif';
import image4 from '@src/assets/images/solution/publicSafety/img/4.avif';
import image5 from '@src/assets/images/solution/publicSafety/img/5.avif';
import image6 from '@src/assets/images/solution/publicSafety/img/6.avif';
import image7 from '@src/assets/images/solution/publicSafety/img/7.avif';
import image8 from '@src/assets/images/solution/publicSafety/img/8.avif';
import image9 from '@src/assets/images/solution/publicSafety/img/9.avif';
import image10 from '@src/assets/images/solution/publicSafety/img/10.avif';

import customer1 from '@src/assets/images/solution/publicSafety/img/customer1.png';
import { publicSafety1, publicSafety2 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '都市安全ソリューション',

  recommend: {
    title: '',
    desc: 'ORBRO OS はリアルタイム位置追跡とスマートモニタリングのための強力なプラットフォームです。<br/>BLE、UWB、および AI ベースの映像分析技術を統合し、公共空間における安全性、効率性、拡張性を強化します。',
    labels: {
      desktop: [
        { img: publicSafety1, data: recommendation.loraGateway },
        { img: publicSafety2, data: recommendation.safetyBell },
      ],
      mobile: [{ data: recommendation.safetyBell }, { data: recommendation.loraGateway }, { data: recommendation.server }],
    },
  },

  banner: {
    title: 'ワンタッチで都市全体をリアルタイムに守る',
    desc: '安心ベルを設置して公共インフラを構築し、市民の安全を即時支援します。',
  },

  summary: {
    title: '都市全体を俯瞰できるモニタリングシステムを構築しましょう。',
    desc: '',
    function: {
      card: [
        {
          image: function1,
          title: 'リアルタイム運用指標ダッシュボード',
          desc: '通報件数、申込数、使用率、年齢別・地域別分布などの主要指標をリアルタイムで集計・可視化します。都市規模での意思決定を助ける設計です。',
        },
        {
          image: function2,
          title: '申込種別ごとの需要推移分析',
          desc: '一人暮らし、店舗、公共施設などの申込数を日別に追跡し、需要のピークタイミングを把握。政策施策や設置時期の戦略立案に役立ちます。',
        },
        {
          image: function3,
          title: '地域別運用データに基づくエリア戦略',
          desc: '安心ベル申込数、登録完了数、実際の通報発生件数を地域別に比較し、優先対応エリアの特定に活かします。',
        },
        {
          image: function4,
          title: '申込から設置までの全プロセス追跡',
          desc: '申込受付から配送、受取、設置完了まで、すべてのステップをシステムで記録。未処理や遅延をリアルタイムで確認可能です。',
        },
      ],
    },
  },

  numOfCard: {
    title: '実際の運用で証明された指標',
    desc: '申込から設置、通報まで、現場での効率と実態を数値で示します。',
    card: [
      {
        tag: '21,480人',
        title: '累計申込数',
        desc: '安心ベルの導入以来の申込数',
      },
      {
        tag: '96.7 ％',
        title: '登録完了率',
        desc: '機器受領後のアプリ登録完了率',
      },
      {
        tag: '62 ％',
        title: '定期テスト利用率',
        desc: '四半期に1回以上のテスト実施率',
      },
    ],
  },

  func: [
    {
      theme: '小さくても賢い緊急通報機を設置しましょう。',
      title: 'ワンタッチで即時通報',
      desc: 'ボタンを押すと自動的に119（または112）に通報され、家族や関係者に SMS 通知が送信されます。スマートフォンがなくても迅速・確実に対応可能です。',
      sub1: '高い信頼性',
      icon1: IconRulerGray,
      sub2: 'リアルタイム状態確認',
      icon2: IconClockGray,
      image: image3,
    },
    {
      title: '壁、柱、出入口付近などに設置可能',
      desc: '電源や工事不要で、屋内外のさまざまな構造物に簡単に取り付けられます。',
      sub2: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub1: '素早いデータ連携',
      icon2: IconTvocGray,
      image: image4,
    },
    {
      title: '動作確認用テストボタン搭載',
      desc: 'テストボタンで動作を簡単に確認でき、運用者・利用者ともに機器状態を日常的にチェックできます。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高い信頼性',
      icon2: IconRulerGray,
      image: image5,
    },
    {
      title: '10年以上稼働する超低消費電力設計',
      desc: 'バッテリー交換や充電不要で、長期的な運用負荷を軽減します。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image6,
    },
    {
      theme: 'アプリで運用を効率化し、対応力を強化しましょう。',
      title: '通報受信・キャンセルをリアルタイムに確認',
      desc: 'アプリで通報の受信状況を確認し、誤通報は2分以内にキャンセル可能です。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image7,
    },
    {
      title: '通報の受信者を自由に設定',
      desc: '119、家族、関係者など、複数の受信者を同時に設定し、公共対応と個人保護を両立させます。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image8,
    },
    {
      title: 'すべての通知履歴を一元管理',
      desc: '通報・キャンセル・テスト通報・電池低下・交換要請など、全ての状態変化をアプリ通知として記録します。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image9,
    },
    {
      title: 'リモートファームウェアアップデート',
      desc: '管理者がアプリ経由で機器のファームウェアを更新でき、追加機器なしで安全に機能改善が可能です。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image10,
    },
  ],

  customer: {
    title: '多くの顧客に選ばれる理由をご紹介します。',
    card: [
      {
        logo: customer1,
        desc: '「導入後、どこで誰がどのように使っているかをリアルタイムで見ることができるのが大きいです。単なる配布ではなく、次に強化すべきエリアをデータで判断できます。」',
        name: '鄭O勇 本部長<br/>京畿道庁',
      },
    ],
  },

  subfunc: {
    title: '機能概要',
    desc: '安全を確保することで効率が上がり、損失が軽減します。ORBRO は、リスクエリアや機器使用時などの様々な場面に適切に対応する機能を提供します。',
    data: [
      {
        icon: IconLocation,
        title: '119 連携 緊急通報',
        desc: 'ボタンを押すと即時に119に通報され、家族へSMSも送信されます。',
      },
      {
        icon: IconLocation,
        title: '通報対象を複数設定可能',
        desc: '119、家族、関係者などを同時に指定できます。',
      },
      {
        icon: IconAnalytics,
        title: '通報キャンセル機能',
        desc: '誤通報時、アプリで2分以内にキャンセル可能です。',
      },
      {
        icon: IconSearch,
        title: 'リモートファームウェア更新',
        desc: 'アプリ経由で安全にファームウェアを更新できます。',
      },
      {
        icon: IconChartBar,
        title: 'バッテリー状態のリアルタイム確認',
        desc: '電力・バッテリーの状態をアプリで確認できます。',
      },
      {
        icon: IconLayers,
        title: '低消費電力による長期稼働',
        desc: '10年間以上、バッテリー交換・充電不要で使用可能です。',
      },
      {
        icon: IconSearch,
        title: '現場での動作確認ボタン',
        desc: '設置後も設置状態を手動で確認できます。',
      },
      {
        icon: IconLayers,
        title: '据え置き型設置構造',
        desc: '壁や柱に固定設置し、移動せず安定して使えます。',
      },
      {
        icon: IconAnalytics,
        title: 'データに基づく運用改善',
        desc: '収集データを基に戦略・改善を検討できます。',
      },
      {
        icon: IconChartBar,
        title: '地域・時間帯別統計分析',
        desc: '地域、タイプ、時間帯ごとの統計をグラフで確認できます。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
